export const getKPColor = (num: number) => {
  if (num >= 9) {
    return "#790000";
  } else if (num >= 8) {
    return "#FF0402";
  } else if (num >= 7) {
    return "#F76400";
  } else if (num >= 6) {
    return "#F8BC00";
  } else if (num >= 5) {
    return "#F6EB14";
  } else {
    return "#92D050";
  }
};

export const getClassColor = (key: string) => {
  const mClassColors: any = {
    b: "#92D050",
    c: "#92D050",
    m1: "#F6EB14",
    m2: "#F8BC00",
    x1: "#F76400",
    x10: "#FF0402",
    x20: "#790000",
  };
  try {
    const str: string = key.replace(/[\d.]+/g, "").toLowerCase();
    const digit: number = parseInt(key.replace(/[^0-9.]/g, ""));
    if (str === "m") {
      if (digit >= 2) {
        return mClassColors.m2;
      } else {
        return mClassColors.m1;
      }
    } else if (str === "x") {
      if (digit >= 20) {
        return mClassColors.x20;
      } else if (digit >= 10) {
        return mClassColors.x10;
      } else {
        return mClassColors.x1;
      }
    } else if (str === "b" || str === "c") {
      return mClassColors[str];
    }
  } catch (error) {
    return "#FFFFFF";
  }
};

type forecast = {
  kp: number;
  predicted_time: string;
};
export const convertArrayToObjectData = (data: forecast[]) => {
  const labels = data.map((obj) => obj.predicted_time);
  const values = data.map((obj) => obj.kp);
  return { labels, values };
};

export const getThaiMonth = (key: number) => {
  const thaiMonths = ["", "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
  return thaiMonths[key];
};

export const getMp4Url = (text: string): string => {
  const srcRegex = /<source\s+src="([^"]+\.mp4)"\s+type="video\/mp4"\s*\/>/;
  const match = text.match(srcRegex);
  if (match && match[1]) {
    return match[1];
  }
  return "";
};

export const formatDateToISOString = (date: Date): string => {
  const year = date.getFullYear().toString().padStart(4, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const getPastDates = (numDays: number): string[] => {
  const pastDates: string[] = [];
  const today = new Date();

  for (let i = numDays - 1; i >= 0; i--) {
    const pastDate = new Date(today);
    pastDate.setDate(today.getDate() - i);
    const formattedDate = formatDateToISOString(pastDate);
    pastDates.push(formattedDate);
  }

  return pastDates;
};

// TODO
// export const findRecordWithMaxDataCount = (records: any[]) => {
//   if (records.length === 0) {
//     return [];
//   }

//   let maxCountRecord = records[0];
//   let maxCount = records[0].data.length;

//   for (let i = 1; i < records.length; i++) {
//     const currentCount = records[i].data.length;
//     if (currentCount > maxCount) {
//       maxCount = currentCount;
//       maxCountRecord = records[i];
//     }
//   }

//   return maxCountRecord;
// };
